import { Modal, Select } from "antd";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import axiosInstance from "../../../variables/api/axiosInstance";

const AddReduction = ({
  show,
  handleClose,
  editMode,
  selectedReduction = {},
  onSuccess,
  existingReductions = [],
}) => {
  const [categories, setCategories] = useState([]);
  const [garanties, setGaranties] = useState([]);
  const [selectedCategorie, setSelectedCategorie] = useState(0);
  const [selectedGaranties, setSelectedGaranties] = useState([]);
  const [nom, setNom] = useState("");
  const [description, setDescription] = useState("");
  const [loading, setLoading] = useState(false);
  const [isDataLoading, setIsDataLoading] = useState(false);

  useEffect(() => {
    if (show && editMode && selectedReduction.nom) {
      setNom(selectedReduction.nom || "");
      setDescription(selectedReduction.commentaire || "");
      setSelectedCategorie(selectedReduction.categorie?.codeCategorie || 0);
      setSelectedGaranties(selectedReduction.garanties || []);
    } else if (show && !editMode) {
      setNom("");
      setDescription("");
      setSelectedCategorie(0);
      setSelectedGaranties([]);
    }

    const fetchCategoriesAndGaranties = async () => {
      setIsDataLoading(true);
      try {
        const [categoriesRes, garantiesRes] = await Promise.all([
          axiosInstance.get(`/api/categorie`),
          axiosInstance.get(`/api/garantie`),
        ]);
        setCategories(categoriesRes.data || []);
        setGaranties(garantiesRes.data || []);
      } catch (error) {
        toast.error("Erreur lors du chargement des catégories et des garanties.");
      } finally {
        setIsDataLoading(false);
      }
    };

    fetchCategoriesAndGaranties();
  }, [show, editMode, selectedReduction]);

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    if (!nom || selectedCategorie === 0 || selectedGaranties.length === 0) {
      toast.error("Veuillez remplir tous les champs obligatoires (Nom, Catégorie, Garanties).");
      setLoading(false);
      return;
    }

    // Vérifier doublon par nom uniquement (mode ajout)
    if (!editMode) {
      const isDuplicate = existingReductions.some(
        (r) => r.nom.trim().toLowerCase() === nom.trim().toLowerCase()
      );
      if (isDuplicate) {
        toast.error("Une réduction avec ce nom existe déjà.");
        setLoading(false);
        return;
      }
    }

    const categorieObj = categories.find(
      (cat) => cat.codeCategorie === selectedCategorie
    );

    const reductionData = {
      ...(editMode && selectedReduction ? selectedReduction : {}),
      nom,
      commentaire: description,
      categorie: categorieObj,
      garanties: selectedGaranties,
    };

    try {
      if (editMode) {
        await axiosInstance.put(`/api/reduction`, reductionData);
        toast.success("Réduction modifiée avec succès !");
      } else {
        await axiosInstance.post(`/api/reduction`, reductionData);
        toast.success("Réduction ajoutée avec succès !");
      }

      handleClose();
      if (typeof onSuccess === "function") onSuccess();
    } catch (error) {
      console.error("Erreur lors de l'opération :", error);
      toast.error("Erreur lors de l'opération.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      open={show}
      onCancel={handleClose}
      footer={null}
      centered
      title={
        <div style={{ textAlign: "center", fontWeight: "bold" }}>
          {editMode ? "Modifier une réduction" : "Ajouter une réduction"}
        </div>
      }
    >
      <form onSubmit={onSubmit}>
        <div className="form-group">
          <label htmlFor="nom">Nom</label>
          <input
            type="text"
            id="nom"
            className="form-control"
            placeholder="Nom de la réduction"
            value={nom}
            onChange={(e) => setNom(e.target.value)}
            required
          />
        </div>
        <div className="form-group">
          <label htmlFor="categorie">Catégorie</label>
          <select
            id="categorie"
            className="form-select"
            value={selectedCategorie}
            onChange={(e) => setSelectedCategorie(e.target.value)}
            required
          >
            <option value="">Sélectionner une catégorie</option>
            {categories.map((cat) => (
              <option key={cat.categorieId} value={cat.codeCategorie}>
                {cat.nom}
              </option>
            ))}
          </select>
        </div>
        <div className="form-group">
          <label htmlFor="garanties">Garanties</label>
          <Select
            mode="multiple"
            style={{ width: "100%" }}
            placeholder="Sélectionner les garanties"
            value={selectedGaranties.map((gar) => gar.codeId.toString())}
            onChange={(values) => {
              const selectedObjects = garanties.filter((g) =>
                values.includes(g.codeId.toString())
              );
              setSelectedGaranties(selectedObjects);
            }}
            options={
              selectedCategorie
                ? garanties
                  .filter(
                    (gar) =>
                      gar.categorie.codeCategorie === selectedCategorie
                  )
                  .map((gar) => ({
                    label: gar.nom,
                    value: gar.codeId.toString(),
                  }))
                : garanties.map((gar) => ({
                  label: gar.nom,
                  value: gar.codeId.toString(),
                }))
            }
          />
        </div>
        <div className="form-group">
          <label htmlFor="description">Description</label>
          <textarea
            id="description"
            className="form-control"
            placeholder="Description de la réduction"
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            required
          />
        </div>
        <div className="text-center mt-4">
          <button type="submit" className="btn btn-primary" disabled={loading}>
            {loading ? "Enregistrement..." : "Enregistrer"}
          </button>
          <button
            type="button"
            className="btn btn-secondary ms-2"
            onClick={handleClose}
          >
            Annuler
          </button>
        </div>
      </form>
    </Modal>
  );
};

export default AddReduction;
